import { createContext } from 'react';

export type AccountCtx = {
  showDeleteAccountConfirmAlert: boolean;
  showDeleteAccountErrorAlert: boolean;
  showDeleteAccountSuccessAlert: boolean;
  deleteAccountError: string;
};

const AccountContext = createContext<AccountCtx>({
  showDeleteAccountConfirmAlert: false,
  showDeleteAccountErrorAlert: false,
  showDeleteAccountSuccessAlert: false,
  deleteAccountError: '',
});

export default AccountContext;